import React from 'react'
import jsPDF from 'jspdf'
import { Button } from 'components'
import { trackButtonInteraction } from 'api/tracking'

const buildPdf = (imgs: string[]) => {
  const pdf = new jsPDF('p', 'mm', [63.5, 88.9])
  imgs.forEach((img, i) => {
    const page = i === 0 ? pdf : pdf.addPage([63.5, 88.9])
    const width = page.internal.pageSize.getWidth()
    const height = page.internal.pageSize.getHeight()
    page.addImage(img, 'PNG', 0, 0, width, height)
  })
  return pdf
}

interface IHandDownloader {
  imgs: string[]
  btnText?: string
}

export const HandDownloader = ({ imgs, btnText }: IHandDownloader) => {
  const [loading, setLoading] = React.useState(false)

  // Download hand as PDF
  const handleDlHand = () => {
    if (!loading) {
      setLoading(true)
      const pdf = buildPdf(imgs)
      const fileName = 'orgasm-order.pdf'
      // pdf.save (depends on FileSaver) is not working on CriOS (Chrome iOS).
      // https://github.com/eligrey/FileSaver.js/issues/467
      // This is slow and causes the UI to block (freezes loading spinner), so not ideal....
      if (
        /CriOS/i.test(navigator.userAgent) &&
        /iphone|ipod|ipad/i.test(navigator.userAgent)
      ) {
        const blob = pdf.output('blob')
        const reader = new FileReader()
        const out = new Blob([blob], { type: 'application/pdf' })
        reader.onload = () => {
          if (typeof reader.result === 'string') {
            window.location.href = reader.result
          }
        }
        reader.onloadend = () => setTimeout(() => setLoading(false), 500)
        reader.readAsDataURL(out)
      } else {
        // The fileName does not actually work on ios safari, I think this is related to the
        // ios webkit a.download attribute support and the MIME type for PDFs.
        pdf.save(fileName)
        setTimeout(() => setLoading(false), 500)
      }

      trackButtonInteraction('Download Your Hand Button', 'Click')
    }
  }

  return (
    <>
      {Boolean(imgs.length) && (
        <Button
          full
          thin
          maxWidth='290px'
          margin={1}
          loading={loading}
          disabled={loading}
          onClick={handleDlHand}
        >
          {btnText || 'Print Your Hand'}
        </Button>
      )}
    </>
  )
}
